import { handleError } from 'services/ErrorService/ErrorService';
import makeCloudFunctionRequest from './makeCloudFunctionRequest';
import { getExpertById, getNominatedExpertQueues, getExperts } from './expertQueries';
import AuthService from 'services/authService';

export const getSimplrExpertPtrId = () => AuthService.current().simplrExpert.id;

export const getLoggedInExpert = async () => {
  if (!AuthService.current()) {
    return {};
  }

  const expertId = getSimplrExpertPtrId();

  const simplrExpert = await getExpertById(expertId);

  if (simplrExpert) {
    return {
      id: simplrExpert.objectId,
      name: simplrExpert.firstName + ' ' + simplrExpert.lastName,
      email: simplrExpert.email,
      username: simplrExpert.userPtr?.username,
      isAdmin: simplrExpert.isAdmin,
      availabilitySwitchLockExp: simplrExpert.availabilitySwitchLockExpiresAt,
      expertToggleLockConfirmation: simplrExpert.expertToggleLockConfirmation,
      availabilityStatus: simplrExpert.availability,
    };
  }
};

export const expertReviewAcknowledgement = async (simplrExpertId) => {
  const params = {
    simplrExpertId,
  };

  try {
    return await makeCloudFunctionRequest('expertReviewAcknowledgement', params);
  } catch (error) {
    handleError({ error });
  }
};

export const expertToggleLockConfirmation = async (simplrExpertId) => {
  const params = {
    simplrExpertId,
  };

  try {
    return await makeCloudFunctionRequest('expertToggleLockConfirmation', params);
  } catch (error) {
    handleError({ error });
  }
};

export const makeAvailable = () => makeCloudFunctionRequest('makeAvailable');

export const makeManualUnavailable = (params) => makeCloudFunctionRequest('makeManualUnavailable', params);

export { getExpertById, getNominatedExpertQueues, getExperts };
